import React from "react";
import reviews from "../assets/reviews.png";
import reviewsMap from "../assets/reviewMap.png";
import box from "../assets/box.png";
import CardList from "./CardList";
import sofa from "../assets/sofa.png";
import openBox from "../assets/openBox.png";

function Aboutus() {
  return (
    <div className="">
      <section className="max-w-7xl mx-auto p-5 xl:p-0 flex flex-col xl:flex-row md:flex-row justify-evenly xl:justify-between md:justify-between min-h-screen z-10 relative">
        <div>
          <br />
          <br />
          <h2 className="text-4xl font-semibold mb-4 text-gray-900 max-w-sm">
            How we are perceived by our{" "}
            <span className="text-green-600">customers</span>
          </h2>
          <p className="max-w-md">
            We have been offering cargo related services since years and
            pleasing our customers time and again.
          </p>
          <button className="pt-3 pb-3 pl-6 pr-6 border border-solid border-cyan-400 rounded-lg text-cyan-400 hover:bg-cyan-400 hover:text-white focus:border-cyan-700 focus:border-2 mt-3">
            All Reviews
          </button>
        </div>
        <div className="mt-10 xl:mt-0 self-end">
          <img src={reviews} alt="reviews" className="z-10" />
        </div>
      </section>
      <img
        src={reviewsMap}
        alt="reviews"
        className="w-screen h-auto overflow-hidden relative bottom-96 -mb-80 hidden xl:block lg:block"
      />

      <CardList />

      <section className="max-w-7xl mx-auto p-5 xl:p-0 min-h-screen xl:-mt-96 md:-mt-96">
        <img
          src={box}
          alt=""
          className="relative top-400px m-auto hidden xl:block md:block"
        />
        <div>
          <br />
          <br />
          <h2 className="text-4xl font-semibold mb-4 text-gray-900 max-w-sm">
            What makes Moverich <br />
            <span className="text-green-600">a right choice.</span>
          </h2>
        </div>
        <div>
          <div className="flex w-full max-w-7xl justify-between mt-10 flex-wrap">
            <div className="w-56 xl:mt-16 md:mt-16 xl:ml-8 md:ml-8 mt-10">
              <h3 className="text-2xl font-semibold mb-4 text-gray-900">
                Licensed and Insured
              </h3>
              <p className="-mt-2">
                Lorem ipsum dolor sit amet, conseurss adipiscing elit. Risus
                accumsan.
              </p>
            </div>
            <div className="w-56 mt-10">
              <h3 className="text-2xl font-semibold mb-4 text-gray-900">
                Customer Service
              </h3>
              <p className="-mt-2">
                Lorem ipsum dolor sit amet, conseurss adipiscing elit. Risus
                accumsan.
              </p>
            </div>
          </div>

          <div className="flex w-full max-w-7xl justify-between xl:mt-28 md:mt-28 mt-12m flex-wrap">
            <div className="w-56 xl:mt-32 md:mt-32 mt-10">
              <h3 className="text-2xl font-semibold mb-4 text-gray-900">
                Professional Moving Crews
              </h3>
              <p className="-mt-2">
                Lorem ipsum dolor sit amet, conseurss adipiscing elit. Risus
                accumsan.
              </p>
            </div>
            <div className="w-56 mt-10">
              <h3 className="text-2xl font-semibold mb-4 text-gray-900">
                Full-Service Movers
              </h3>
              <p className="-mt-2">
                Lorem ipsum dolor sit amet, conseurss adipiscing elit. Risus
                accumsan.
              </p>
            </div>
          </div>

          <div className="flex w-full max-w-4xl xl:justify-end md:justify-end xl:mt-28 md:mt-28 mt-12">
            <div className="w-56 xl:self-end md:self-end">
              <h3 className="text-2xl font-semibold mb-4 text-gray-900">
                Properly Equipped
              </h3>
              <p className="-mt-2">
                Lorem ipsum dolor sit amet, conseurss adipiscing elit. Risus
                accumsan.
              </p>
            </div>
          </div>
        </div>
      </section>

      <br />
      <br />
      <br />
      <br />

      <section className="max-w-7xl mx-auto p-5 xl:p-0 min-h-screen ">
        <div>
          <br />
          <br />
          <h2 className="text-4xl font-semibold mb-4 text-gray-900 max-w-sm">
            Choosing the right service
            <span className="text-green-600"> for you.</span>
          </h2>
        </div>
        <br />
        <br />
        <div className="flex max-w-7xl w-full justify-between align-middle flex-wrap">
          <img src={sofa} alt="" className="max-h-96 w-auto" />
          <div className="mt-10">
            <p className="max-w-lg">
              We understand how tricky and stressful it is to pack the entire
              stuff, transport it to a new location, and unload it. But we
              promise dedication, honesty, and sincerity in offering you the
              best and satisfying cargo related services.
              <br /> <br />
              High quality, committed, and professional cargo-related services –
              this is what we strive for. And for that, we do not compromise on
              any factor. You can expect skilled services from our team of
              qualified and experienced staff.
            </p>
            <button className="pt-3 pb-3 pl-6 pr-6 border border-solid border-cyan-400 rounded-lg text-cyan-400 hover:bg-cyan-400 hover:text-white focus:border-cyan-700 focus:border-2 mt-3">
              Customer Guide
            </button>
            <img src={openBox} alt="" className="float-right mt-16" />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Aboutus;
